function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M17.465,18.393A10.508,10.508,0,1,1,9.859.03v4.4a6.128,6.128,0,1,0,4.5,10.864Z",
  transform: "translate(0 -0.03)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.155,12.75a10.32,10.32,0,0,1-2.608,6.282l-3.1-3.1a6.027,6.027,0,0,0,1.312-3.185Z",
  transform: "translate(-2.155 -1.6)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M22.568,9.848H18.175A6.108,6.108,0,0,0,12.75,4.423V.03A10.487,10.487,0,0,1,22.568,9.848Z",
  transform: "translate(-1.567 -0.03)"
});

function SvgIboss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIboss);
export default __webpack_public_path__ + "static/media/iboss.f43ef1de.svg";
export { ForwardRef as ReactComponent };